<input
  #input
  class="email-input"
  type="email"
  inputmode="email"
  autocomplete="off"
  [class.form-error-border]="error"
  [attr.id]="controlId"
  [attr.aria-invalid]="error ? true : null"
  [value]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  (input)="handleInput($event)"
  (blur)="handleBlur()" />
